import { Typography } from '@mui/material';
import RenterInviteDrawerForm from './RenterInviteDrawerForm';
import RenterInviteForm from './RenterInviteForm';
import { useRenterInviteController } from './useRenterInvite.controller';

export type RenterInviteDrawerFormContentProps = {
  onSuccess?: () => void;
};

const RenterInviteDrawerFormContent = ({ onSuccess }: RenterInviteDrawerFormContentProps) => {
  const { user, errorMsg, isSmbRenterInvites, useNewForm, customCoverageDisabled, onSubmit } =
    useRenterInviteController({ onSuccess });

  return (
    <>
      <Typography mb={4}>
        Please fill out your renter's information below, and we will send them an invitation to
        apply using the email address provided. Providing complete information will help to ensure
        an efficient quoting process for your renter.
      </Typography>
      {isSmbRenterInvites ? (
        <RenterInviteDrawerForm
          user={user}
          onSubmit={onSubmit}
          errorMsg={errorMsg}
          newCoveragesEnabled={useNewForm}
        />
      ) : (
        <RenterInviteForm
          onSubmit={onSubmit}
          errorMsg={errorMsg}
          customCoverageDisabled={customCoverageDisabled}
        />
      )}
    </>
  );
};

export default RenterInviteDrawerFormContent;
